export interface IBaseTransportOptions {
	protocol: string;
	address: string;
}
